import { useMediaQuery } from "./useMediaQuery";

/** En dessous, l'app passe sur son shell mobile. */
export const MOBILE_BREAKPOINT = 768;

/**
 * Initialisé de façon synchrone (cf. `useMediaQuery`) : un état parti de
 * `false` montait d'abord tout le canvas desktop sur un téléphone, requêtes
 * comprises, avant de basculer sur le shell mobile.
 */
export function useIsMobile() {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}
